import auth from './auth'
import repricing from './repricing'
import shops from './shops'
import product from './product'
import notifications from './notifications'
import experiments from './experiments'

export {auth, repricing, shops, product, notifications, experiments}



// WEBPACK FOOTER //
// ./src/services/index.js